import angular from 'angular';
/**
 * m.numedit -- directives for smart numeric editors/validators
 *  - smartInteger
 *  - smartFloat
 */
/**
 * History
 *
 * v1.0  3.4.2016  - copied current version from sastamala repo 1dbdfc9a + renamed as m.numedit
 *
 * v1.1  11.5.2017 - update from sastamala repo current rev
 *  * more consistent smartInteger: empty is valid (required check is different thing), set viewValue as integer
 *
 * v1.2  20.8.2018 - convert empty string (accepted as valid) to null to avoid setting numeric
 *                   properties as ""
 *
 * v1.3  16.3.2019 - smart-integer allows integers greater than 32 bit integer max
 *
 * v1.4  15.8.2021 - typescript
 *
 * v1.5  16.7.2023 - support negative and min/max
 *
 * v1.6  20.8.2023 - fix types with @types/angular installed
 */
const numeditModule = angular.module('m.numedit', [])
    .directive('smartFloat', function () {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            if (!ctrl) {
                throw new Error('Controller must be defined');
            }
            const FLOAT_REGEXP = /^\-?\d+((\.|\,)\d+)?$/;
            const MIN_CONSTRAINT = attrs.min !== undefined ? Number(attrs.min) : undefined;
            const MAX_CONSTRAINT = attrs.max !== undefined ? Number(attrs.max) : undefined;
            const validator = function (viewValue) {
                if (FLOAT_REGEXP.test(viewValue)) {
                    const value = parseFloat(viewValue.replace(',', '.'));
                    ctrl.$setValidity('float', true);
                    // check min/max constraints.
                    // validity keys min/max are set also with the standard min/max attributes for number types,
                    // but it doesn't seem to work for us
                    if (MIN_CONSTRAINT !== undefined) {
                        ctrl.$setValidity('min', value >= MIN_CONSTRAINT);
                    }
                    if (MAX_CONSTRAINT !== undefined) {
                        ctrl.$setValidity('max', value <= MAX_CONSTRAINT);
                    }
                    return value;
                }
                else {
                    // value that does not pass regexp is valid float only if it is empty string or undefined
                    // SA: 3.4.2016: allow also explicit nulls (treat similar as undefined)
                    ctrl.$setValidity('float', (viewValue === '' || viewValue === undefined || viewValue === null));
                    // show the value even if not valid, however convert
                    // empty string to null to avoid setting "" for properties expecting a
                    // number
                    return viewValue === '' ? null : viewValue;
                }
            }; // validator
            ctrl.$parsers.unshift(validator); // user input validation
            ctrl.$formatters.unshift(validator); // initial value validation
        }
    };
})
    .directive('smartInteger', function () {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            if (!ctrl) {
                throw new Error('Controller must be defined');
            }
            const MIN_CONSTRAINT = attrs.min !== undefined ? Number(attrs.min) : undefined;
            const MAX_CONSTRAINT = attrs.max !== undefined ? Number(attrs.max) : undefined;
            const validator = function (viewValue) {
                const n = Math.floor(viewValue);
                if (String(n) === viewValue) {
                    // valid integer inputted
                    ctrl.$setValidity('integer', true);
                    // check min/max constraints.
                    // validity keys min/max are set also with the standard min/max attributes for number types,
                    // but it doesn't seem to work for us
                    if (MIN_CONSTRAINT !== undefined) {
                        ctrl.$setValidity('min', n >= MIN_CONSTRAINT);
                    }
                    if (MAX_CONSTRAINT !== undefined) {
                        ctrl.$setValidity('max', n <= MAX_CONSTRAINT);
                    }
                    return n;
                }
                else {
                    // SA: 27.10.2016: tyhjä merkkijono / explicit nullit on ok
                    // (required validointi erikseen)
                    ctrl.$setValidity('integer', (viewValue === '' || viewValue === undefined || viewValue === null));
                    return viewValue; // show the value even if not valid
                }
            };
            ctrl.$parsers.unshift(validator); // user input validation
            ctrl.$formatters.unshift(validator); // initial value validation
        }
    };
});
export default numeditModule.name;
